import type { Document as RichTextDocument } from '@contentful/rich-text-types';
import type { ComponentProps, ReactNode } from 'react';

import RichText from '@/components/RichText/RichText';

interface LeadFormTCPAProps {
  text: RichTextDocument;
  className?: string;
  checkboxSlot?: ReactNode;
  blockClasses?: ComponentProps<typeof RichText>['blockClasses'];
  isOnDark?: boolean;
}

export function LeadFormTCPA({
  text,
  className,
  checkboxSlot,
  blockClasses,
  isOnDark,
}: LeadFormTCPAProps) {
  return (
    <label style={{ display: 'block' }}>
      {/** biome-ignore lint/correctness/useUniqueElementIds: Automated migration to Biome */}
      <input
        type='hidden'
        id='leadid_tcpa_disclosure'
        name='Terms of Service'
      />
      {checkboxSlot}
      <RichText
        title=''
        content={text}
        className={className}
        blockClasses={blockClasses}
        isOnDark={isOnDark}
      />
    </label>
  );
}
